import "altcha";
import type { AltchaWidgetElement } from "altcha/types/generic";

document.addEventListener("DOMContentLoaded", () => {
    const widget = document.querySelector<AltchaWidgetElement>("#altcha");
    if (widget) {
        widget.configure({
            hideFooter: true,
            hideLogo: true
        });
        widget.addEventListener("statechange", (event) => {
            const customEvent = event as CustomEvent;
            const sendButton = document.querySelector<HTMLButtonElement>("#SendButton");
            if (sendButton) {
                sendButton.disabled = customEvent.detail.state !== "verified";
            }
        });
    }
});
